<template>
    <div>
        <div
            v-if="! rowsCategories"
            class="alert alert-warning"
            role="alert"
        >
            {{ $t('loading') }}...
        </div>

        <div class="row">
            <div class="col-md-3 col-12">
                <div class="list-group mb-5">
                    <button
                        v-for="category in rowsCategories"
                        :key="category.id"
                        type="button"
                        :class="{
                            active: (selectedCategory && (category.id === selectedCategory.id)),
                        }"
                        class="list-group-item list-group-item-action"
                        @click.stop.prevent="selectCategory(category)"
                    >
                        {{ $t(`categories.${category.slug}`) }}
                    </button>

                    <button
                        type="button"
                        :class="{
                            active: (selectedCategory === null),
                        }"
                        class="list-group-item list-group-item-action"
                        @click.stop.prevent="showBookmarks()"
                    >
                        <font-awesome-icon icon="fa-solid fa-heart" class="mr-1" />
                        {{ $t('myFavourites') }}
                    </button>

                    <router-link
                        to="/languages"
                        target="_blank"
                        class="list-group-item list-group-item-action"
                    >
                        <font-awesome-icon icon="fa-solid fa-external-link" class="mr-1" />
                        {{ $t('languages.languages') }}
                    </router-link>
                </div>
            </div>

            <div class="col">
                <div
                    v-if="(rowsCategories && isLoading)"
                    class="alert alert-warning"
                    role="alert"
                >
                    {{ $t('loading') }}...
                </div>

                <div class="row">
                    <series-item
                        v-for="series in rowsSeries"
                        :key="series.id"
                        :series="series"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import SeriesItem from './SeriesItem.vue';
import { kebabCase } from "lodash";

export default {
    name: "FullSeriesList",

    components: {
        SeriesItem,
    },

    data() {
        return {
            isLoading: true,
            rowsCategories: [],
            rowsSeries: [],
            selectedCategory: {},
        };
    },

    setup() {
        return {
          kebabCase,
        };
    },

    watch: {
        selectedCategory: function (value) {
            let url = '';

            if(value) {
                // get series by category
                url = `/subscriber/api/categories/${this.selectedCategory.id}/series`;
            } else {
                // get series by user bookmarks
                url = '/subscriber/api/user/bookmarks';
            }

            this.getSeries(url);
        },
    },

    mounted: function () {
        this.getCategories();
    },

    methods: {
        getCategories: function () {
            axios({
                method: 'get',
                url: '/subscriber/api/categories/',
            })
            .then((response) => {
                this.rowsCategories = response.data;
                this.selectedCategory = this.rowsCategories[0];
            });
        },

        getSeries: function (url) {
            this.rowsSeries = [];
            this.isLoading = true;

            axios({
                method: 'get',
                url: url,
            })
            .then((response) => {
                this.rowsSeries = response.data;
            })
            .catch(() => {})
            .then(() => {
                this.isLoading = false;
            });
        },

        selectCategory: function (category) {
            this.selectedCategory = category;
        },

        showBookmarks: function () {
            this.selectedCategory = null;
        },
    },
};
</script>
